import { createSelector } from '@ngrx/store';
import { AssessmentPageState, AssessmentState } from '../models/assessment-models';

export const selectInitialAssessment = (state: any): AssessmentState => state.initialAssessment;

export const selectInitialAssessmentState = createSelector(selectInitialAssessment, (state) => state?.testletConfig);

export const selectInitialAssessmentLoading = createSelector(selectInitialAssessmentState, (state) => state?.loading);

export const selectInitialAssessmentError = createSelector(selectInitialAssessmentState, (state) => state?.error);

export const selectUpdateAssessment = (state: any): AssessmentState => state.updateAssessment;

export const selectUpdateAssessmentState = createSelector(selectUpdateAssessment, (state) => state?.testletConfig);

export const selectUpdateAssessmentLoading = createSelector(selectUpdateAssessmentState, (state) => state?.loading);

export const selectUpdateAssessmentError = createSelector(selectUpdateAssessmentState, (state) => state?.error);

export const selectCurrentUpdateAssessmentState = createSelector(selectUpdateAssessmentState, (state) => state);

export const selectAssessmentState = (state: any): AssessmentPageState => state.setAssessment;

export const selectAssessmentId = createSelector(selectAssessmentState, (state) => state.assessmentId);
